import { Badge, Divider, IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Popover, Tooltip } from "@material-ui/core";
import React, { useState } from "react";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";
import { combineProps } from "../../../../helpers/objectHelper";
import { formatTime } from "../../../../helpers/time.helper";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import { eventLabelGroupsConstants } from "../../../constants/eventLabelGroups.contansts";
import { ScrollWrapper } from "../../../helpers/module.helper";
import { ChatAvatar } from "./ChatAvatar";
import { ChatSearchbar } from "./ChatSearchbar";
import { NoResultState } from "./shared/NoResultState";
import GroupIcon from "@material-ui/icons/Group";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import QuestionAnswerIcon from "@material-ui/icons/QuestionAnswer";
import PersonRoundedIcon from "@material-ui/icons/PersonRounded";
import { PersonInformationPopover } from "./shared/PersonInformationPopover";

export function ConversationListPopover(props) {
  const [anchorEl, setAnchorEl] = useState(null);

  const { icon, tooltipText, chatTemplate, preview, children } = props;
  const { primaryColor } = chatTemplate;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "conversation-popover" : undefined;
  return (
    <div style={{ position: "relative" }}>
      <IconButton aria-describedby={id} disabled={preview} onClick={handleClick} style={{ color: primaryColor, padding: "8px" }}>
        <BadgeWrapper {...props}>
          <Tooltip title={<EventLabel2 name={"MyConversations"} groupName={eventLabelGroupsConstants.CHAT_LABEL_GROUP} />}>
            <QuestionAnswerIcon />
          </Tooltip>
        </BadgeWrapper>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div className="action-popover">
          <ConversationList {...combineProps([props, { handleClose }])} />
        </div>
      </Popover>
    </div>
  );
}
const BadgeWrapper = (props) => {
  const { badgeValue, children, chatTemplate } = props;
  const { badgePillColor, secondaryColor } = chatTemplate;
  if (!badgeValue) return children;
  return (
    <Badge
      badgeContent={
        <div
          style={{
            padding: "3px 5px",
            background: badgePillColor,
            color: secondaryColor,
            borderRadius: "40%",
          }}
        >
          {badgeValue}
        </div>
      }
    >
      {children}
    </Badge>
  );
};

function ConversationList(props) {
  const [filter, setFilter] = useState("");
  const { connectionList, orderList, selectChat, callback, chats } = props;
  /*   const searchString = (order) => {
    if (!filter) return true;
    return (
      order.name.toLowerCase().includes(filter.toLowerCase()) ||
      order.company.toLowerCase().includes(filter.toLowerCase())
    );
  }; */
  const restrictions = (chat) => {
    const { allowModeratorChat, disableGroupChat } = props;
    if (filter && !orderList.find((order) => (order.name.toLowerCase().includes(filter.toLowerCase()) || order.company.toLowerCase().includes(filter.toLowerCase())) && chat.target == order.badgeNo)) {
      return false;
    }
    if (!allowModeratorChat && chat.target == "MODERATOR") return false;
    if (disableGroupChat && chat.target == "ALL") return false;
    return true;
  };
  const conversations = chats.filter(restrictions);
  return (
    <div style={{ width: "100%", height: "100%", backgroundColor: "#fff" }}>
      <div
        style={{
          padding: "5px 10px",
          fontSize: "1rem",
          fontWeight: 600,
          fontFamily: "Arimo",
        }}
      >
        <EventLabel2 name="MyConversations" groupName={eventLabelGroupsConstants.CHAT_LABEL_GROUP} />
      </div>
      <ChatSearchbar filter={setFilter} />
      <ScrollWrapper {...props}>
        <List className="jir-scroll">
          {conversations.length > 0 ? (
            conversations.map((c, i) => {
              const person = orderList.find((o) => o.badgeNo == c.target);
              return (
                <div key={i}>
                  <ConversationListItem person={person} {...combineProps([c, props])} />
                </div>
              );
            })
          ) : (
            <NoResultState />
          )}
        </List>
      </ScrollWrapper>
    </div>
  );
}

const ConversationListItem = (props) => {
  const { selectChat, person, target, chatTemplate, clientKey, seen, handleClose } = props;
  return (
    <ListItem
      className="chat-list-item"
      onClick={() => {
        selectChat(target);
        handleClose();
      }}
    >
      {!seen ? <div className="notice-dot2" /> : null}
      <ListItemAvatar>
        <PersonInformationPopover
          {...combineProps([
            props,
            {
              target,
            },
          ])}
        >
          <ChatAvatar {...combineProps([props, chatTemplate])}>
            <ChatIcon {...props} />
          </ChatAvatar>
        </PersonInformationPopover>
      </ListItemAvatar>
      <ListItemText primary={<span style={{ fontWeight: "bold", fontFamily: "Arimo" }}>{conversationReceiver(props)}</span>} secondary={conversationPreviewText(props)} />
    </ListItem>
  );
};

const ChatIcon = ({ target, person }) => {
  if (target == `ALL`) return <GroupIcon />;
  else if (target == `MODERATOR`) return <VerifiedUserIcon />;
  else if (person) return <PersonRoundedIcon />;
  return null;
};

const conversationPreviewText = (props) => {
  const { lastChange, messages, previewPreFix, senderFirstName, orderList, previewText, person, clientKey } = props;

  let senderOfLastMessage = null;

  if (messages.length == 0) return <SystemLabel name="TypeSomething" />;
  if (messages.length > 0 && clientKey == messages[messages.length - 1].sender) {
    senderOfLastMessage = <SystemLabel name="You" />;
  } else {
    const lastMessage = messages[messages.length - 1];
    const sender = orderList.find((ol) => ol.badgeNo == lastMessage.sender);
    senderOfLastMessage = sender ? sender.name : <SystemLabel name="Guest" />;
  }

  return (
    <span>
      {senderOfLastMessage}: {previewText.substring(0, 20)} • {formatTime(lastChange)}
    </span>
  );
};

const conversationReceiver = ({ person, target }) => {
  if (target == "ALL") return <EventLabel2 name="OpenChat" groupName={eventLabelGroupsConstants.CHAT_LABEL_GROUP} />;
  else if (target == "MODERATOR") return <EventLabel2 name="Moderator" groupName={eventLabelGroupsConstants.CHAT_LABEL_GROUP} />;
  else if (person) return person.name;
  else return "";
};
